<template>
  <p class="field" :class="{ 'invalid': isInvalid }">
    <label @click.prevent v-if="this.$slots.default">
      {{ fullLabel }}
    </label>
    <slot />
    <span v-if="isInvalid" class="invalid_help">
      {{ error.msg }}
    </span>
  </p>
</template>

<script>
export default {
  name: 'app-settings-input',
  props: {
    label: String,
    error: {
      type: Object,
      default() {
        return {}
      }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fullLabel() {
      return this.label + (this.required ? ' *' : '')
    },
    isInvalid() {
      return 'field' in this.error
    }
  }
}
</script>

